import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Building2, ShieldAlert, Activity } from 'lucide-react';

export const PlatformLayout: React.FC = () => {
  return (
    <div className="flex flex-col h-screen w-screen overflow-hidden bg-background text-foreground">
      {/* Top Bar */}
      <div className="h-14 shrink-0 bg-card border-b border-border flex items-center justify-between px-6">
        <div className="flex items-center gap-2 font-bold text-lg">
          <ShieldAlert className="h-5 w-5 text-primary" />
          <span className="text-primary truncate">Platform Admin</span>
        </div>
      </div>

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar Navigation */}
        <div className="w-64 border-r border-sidebar-border bg-sidebar flex flex-col shrink-0">
          <div className="flex-1 overflow-y-auto py-4 px-3 flex flex-col gap-1">
            <NavLink
              to="/platform/dashboard"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-semibold transition ${
                  isActive
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'text-muted-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
                }`
              }
            >
              <LayoutDashboard className="h-4.5 w-4.5" />
              <span>Dashboard</span>
            </NavLink>
            <NavLink
              to="/platform/workspaces"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-semibold transition ${
                  isActive
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'text-muted-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
                }`
              }
            >
              <Building2 className="h-4.5 w-4.5" />
              <span>Workspaces</span>
            </NavLink>
            <NavLink
              to="/platform/users"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-semibold transition ${
                  isActive
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'text-muted-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
                }`
              }
            >
              <Users className="h-4.5 w-4.5" />
              <span>Users</span>
            </NavLink>
            <NavLink
              to="/platform/workforce"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-semibold transition ${
                  isActive
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'text-muted-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
                }`
              }
            >
              <Activity className="h-4.5 w-4.5" />
              <span>Workforce Activity</span>
            </NavLink>
          </div>
          <div className="p-4 border-t border-sidebar-border">
            <NavLink
              to="/app"
              className="flex items-center justify-center w-full px-4 py-2 border border-border rounded-xl text-xs font-semibold hover:bg-muted text-foreground transition"
            >
              Back to App
            </NavLink>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 overflow-y-auto bg-muted/20 relative p-6 pt-4">
          <div className="bg-card border border-border rounded-2xl shadow-sm min-h-full flex flex-col p-8 pt-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
